<img class="p-1" [src]="ProviderData?.image" width="100px">

